module.exports = __webpack_public_path__ + "img/pixartprinting-logo.18504cf.svg";